<template>
  <div class="content">
    <h2>招聘信息</h2>
    <div class="content-single" v-for="(item, index) in list" :key="index">
      <div class="title">
        <h4 style="line-height: 80px">{{ item.name }}</h4>
      </div>
      <h5>{{ item.dutyName }}</h5>
      <p v-for="itm in item.duty" :key="itm">{{ itm }}</p>
      <h5>{{ item.chaimName }}</h5>
      <p v-for="itm2 in item.chaim" :key="itm2">{{ itm2 }}</p>
      <h5>
        工作地点：
        <p
          style="
            font-size: 18px;
            color: #000000;
            display: inline-block;
            margin-left: 5px;
            padding-bottom: 1px;
          "
        >
          {{ item.title }}
        </p>
      </h5>
      <div class="container-resume">
        <button
          class="resume"
          @click="showResume"
          :data-index="index"
          v-if="item.isShow.isShowResume"
        >
          投递简历
        </button>
        <div v-if="item.isShow.isShowUpLoad">
          <div class="resume-detail" style="position: relative">
            <a href="javascript:;" class="file">
              <input
                type="file"
                @change="selectFile"
                :data-index="index"
                ref="dragFile"
                style="width: 100%; height: 100%"
              />
            </a>
            <div class="fileLogo" v-if="item.isShow.isShowFileLogo">
              <span
                style="
                  line-height: 70px;
                  color: #ffffff;
                  display: block;
                  text-align: center;
                "
                >{{ item.title }}</span
              >
            </div>
            <span
              v-if="!item.isShow.isShowFileLogo"
              class="icon iconfont icon-up"
              style="
                width: -webkit-fit-content;
                font-size: 1.875rem;
                line-height: 1.875rem;
              "
            ></span>
            <span
              v-if="!item.isShow.isShowFileLogo"
              style="
                width: -webkit-fit-content;
                font-size: 0.75rem;
                line-height: 1.875rem;
              "
              >文字简历</span
            >
          </div>
          <p style="color: rgb(178, 178, 178); margin-left: 0px">
            注：可上传文件格式 pdf、doc、docx。文字简历不超过2M。
          </p>
          <button class="resume" @click="upLoad" :data-index="index">
            上传
          </button>
          <button class="light" @click="cancelUpLoad" :data-index="index">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "../../services/fetch.js";
import axiox from "axios";
import fs from "fs";
export default {
  name: "Invite",
  data() {
    return {
      selectedFile: null,
      hint: "",
      list: [
        {
          name: "【中级游戏策划】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、参与整个游戏设计,制定完善设计文档,负责功能细节设计、界面及操作设计,注重用户操作体验；",
            "2、配合程序完成游戏系统及各功能模块,并对功能进行验收和测试,保证功能质量,修正和完善在制作和测试过程中发现的缺陷和不足；",
            "3、能够针对游戏的运营数据进行分析、总结,提出具有建设性的意见及建议。",
          ],
          chaim: [
            "1、3年以上工作经验；",
            "2、熟练使用Word，Excel，Axure等基本办公软件；",
            "3、有良好的逻辑思维能力,学习能力，擅长项目研发中的沟通和执行能力；",
            "4、协调程序、美术、策划等资源，驱动目标达成。",
          ],
          isShow: {
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【高级游戏策划】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、负责竞品及行业分析，及时把握行业动向，确定产品方向，分析项目可行性；",
            "2、负责游戏风格制定，游戏主体架构和主体逻辑规则搭建，规划和设计数值框架、核心玩法、各系统功能；",
            "3、负责策划组织的工作安排、指导培养及监督，建立敏捷有效的创新孵化机制；",
            "4、协调程序、美术、营销等资源，驱动目标达成。",
          ],
          chaim: [
            "1、热爱游戏事业，具备创业激情和心态，有良好的团队精神以及协调能力；",
            "2、5年以上游戏策划经验，1年手游主策经验或成功产品核心策划经验，",
            "3、熟练策划部门运作，对功能、数值、剧情策划都有一定程度了解，能指导其完成细化工作，对策划组工作进行合理的人员、时间安排，并予以监督和负责；",
            "4、熟练掌握整个游戏产品开发工作流程，对程序，美术的工作有一定了解；",
            "5、具备较好的数学功底，有良好数值感受，逻辑演算与评估能力，对游戏数值方面有较深入研究者优先；",
            "6、熟悉玩家心理，针对特定用户群体，有一定市场分析能力。",
          ],
          isShow: {
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【资深原画】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、配合项目已制定游戏风格，输出原画设计模版和规范；",
            "2、根据项目要求，为游戏绘制符合游戏风格的角色原画；",
            "3、参与具体原画设计任务，审核外包提交的设计稿，指导外包制作；",
            "4、负责原画和其他环节的对接 保证最终游戏输出原画效果 ；",
          ],
          chaim: [
            "1、热爱游戏，关注游戏体验，结合本岗位工作配合产品改进游戏体验；",
            "2、专科以上，美术相关类专业毕业，深厚的美术功底；",
            "3、5年以上原画设计经验，熟悉游戏原画设计流程和规范，能快速适应各种风格；",
            "4、有较强的综合分析能力，创新能力，准确理解工作需求并高效完成；",
            "5、有较强的工作责任心，工作投入度高，能承受较强的压力，具备良好的沟通及团队合作能力，配合团队完成目标；",
            "6、懂场景、ui设计、动作、特效等制作流程的优先；",
            "7、熟练掌握该岗位所需软件，有较强的学习能力，主动研究或学习新的技术运用到工作中。",
            "（应聘此职位请在邮件中附上近期个人原创作品）",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【游戏原画】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、根据项目需求进行游戏角色和场景的艺术设定创作;",
            "2、配合项目已制定游戏风格，输出原画设计模版和规范；",
            "3、配合策划、程序以及美术其他岗位，跟进原画在游戏内的实现。",
          ],
          chaim: [
            "1、熟练掌握ps、sai、painter工具，擅长卡通Q版；",
            "2、热爱游戏，对游戏原画有自己的理解，独特的原画风格；",
            "3、美术手绘功底出众，较强的审美和创意思维，能对优秀案例进行解构分析，并吸收总结；",
            "4、工作稳定性好，承压能力要强，工作中喜欢追求极致，有良好的沟通和团队协作能力；",
            "5、请附带个人创作作品及简历投递至邮箱。",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【游戏美宣/平面设计】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、与运营人员对接为游戏设计推广用的素材（游戏推广横幅banner、图标icon、GIF动图、游戏分享图等美宣图）；",
            "2、参与游戏的其他美术设计，与游戏的相关美术资源；",
          ],
          chaim: [
            "1、有一定的美术审美功底，能够适应不同美术风格和配色方案；",
            "2、熟练使用二维绘画软件Ps，Illustrator，可借助3ds Max软件实现创意想法，会动画制作软件优先考虑；",
            "3、熟悉游戏常见风格，具备一定的产品市场定位分析、视觉创意能力。",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【2D/3D游戏动画】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、 熟练使用spine或Dragon Bones软件制作2D骨骼动画；",
            "2、能准确理解策划设计意图，通过原画提供分镜，融合自己理解完成动画制作；",
            "3、与美术和团队进行良好的沟通，准确实现项目开发需求。",
          ],
          chaim: [
            "1、对游戏及动画有深刻认识，拥有一年以上游戏动画制作经验优先；",
            "2、熟练使用spine、Dragon Bones软件，懂得运动规律，有很丰富的创造力；",
            "3、会使用FLASH软件制作逐帧动画，熟悉fIasHAECOCOS粒子动画。",
            "4、熟练掌握photoshop等常用软件；",
            "5、有一定的贴图绘制、拆骨骼块修改能力；",
            "6、有一定的逐帧动画绘制能力；",
            "7、擅长基本的Ul、特效制作优先；",
            "8、有一定的原画绘制功底，能够自己完成补面切图等工作。",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【Cocos程序员】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、负责公司旗下微信小游戏，休闲类游戏开发工作；",
            "2、根据游戏策划需求，独立设计开发相应的游戏功能模块；",
            "3、持续优化项目性能和兼容性，不断改善用户体验；",
          ],
          chaim: [
            "1、专科及以上学历，计算机相关专业；",
            "2、一年以上cocos游戏开发经验；",
            "3、有Cocos Creator/Cocos2D-X/Cocos2D-JS游戏开发经验优先；",
            "4、熟悉Cocos Creator游戏开发工具、熟悉 javascript或typerscript开发语言；",
            "5、能独立完成小游戏客户端项目开发；",
            "6、熟悉微信小游戏接口，微信小游戏开发流程优先；",
            "7、热爱网络游戏、逻辑能力强、喜欢钻研技术，具有较强的学习能力和良好的沟通能力、较好的团队协作能力，能承担一定的工作压力。",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【CocosCreator 高级工程师】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、负责公司开发框架维护和更新；",
            "2、负责第三方SDK接入；",
            "3、负责产品功能需求开发；",
            "4、辅助其他研发人员解决项目遇到的难题。",
          ],
          chaim: [
            "1、熟练应用JS或TS语言，熟练运用CocosCreator引擎；",
            "2、有优化包体大小、游戏运行效率、游戏体验的经验；",
            "3、熟悉常用游戏算法，有较强的逻辑思维；",
            "4、了解Android、iOS等APP渠道上架流程；",
            "5、数量使用各种调试工具，掌握各种调试技巧，能够快速定位问题；",
            "6、了解Cocos引擎源码设计，具备优化和修改引擎功能的能力；",
            "7、了解各种H5、小游戏环境，了解移动设备的兼容和适配问题；",
            "8、了解JNI、引擎JSB模块；",
            "9、了解Node.JS，能够开发CocosCreator编辑器插件；",
            "10、了解常用的设计模式，了解ECS，了解跨平台框架的兼容设计；",
            "11、代码整洁，注释完整清晰易于理解；",
            "12、熟悉LayaAir2引擎的优先；",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【laya程序员】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、负责使用Laya引擎进行游戏开发与维护；",
            "2、优化性能，修改测试人员提交的BUG；",
            "3、与策划沟通对接，制定开发方案的落地实施；",
          ],
          chaim: [
            "1、熟练掌握Typescript；",
            "2、熟练操作Laya、Unity游戏引擎进行3D超休闲游戏开发；",
            "3、比较深入了解Laya引擎的3D性能，有Laya引擎3D游戏的完整上线作品;",
            "4、资深Unity3D引擎使用经验者，且有完整U3D游戏项目在App Store上线;",
            "5、对shader有深入研究者优先，有知名项目经验者优先；",
            "6、计算机专业出身者优先，有知名游戏公司开发经验者优先；",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【U3D】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、游戏客户端界面与逻辑代码开发；",
            "2、根据策划要求完成相关模块功能开发；",
            "3、客户端代码的测试与维护；",
          ],
          chaim: [
            "1、计算机相关专业毕业，面向2021年毕业实习生；",
            "2、能熟练使用unity开发工具；",
            "3、熟悉C/C++，java, Object C 或者C#任何一种开发语言，熟悉基本算法和数据结构；",
            "4、思维活跃，具有严谨的逻辑推理能力；",
            "5、英语水平良好，能熟练阅读英文技术文档，具有良好的自学能力者优先；",
            "6、具有良好的编程风格，以及文档编写和版本管理能力；",
            "7、热爱游戏行业，有开发移动平台游戏经验者优先。",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【游戏运营助理】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、负责小游戏的运营工作，进行评测、跟进上线维护；",
            "2、通过运营思维和数据分析调整运营策略，提高产品量级，增强用户留存和转化；",
            "3、较强的版本调优能力，根据运营情况提出优化方案，对竞品进行分析，挖掘痛点，完善版本；",
            "4、持续监控用户行为数据进行汇总，跟踪和评估运营效果，及时处理各类游戏突发问题；",
            "5、不断跟踪和评估运营效果，分析运营数据，定期总结汇报。",
          ],
          chaim: [
            "1、热爱游戏，求知欲旺盛，游戏经验丰富；",
            "2、具有整体把握的思维，执行能力强，推动能力强；",
            "3、时间管理能力强，具备提前规划的习惯并能按计划严谨执行；",
            "4、勤思考，有良好的自我总结习惯，注重培养自己的方法论体系。",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【游戏商务助理（无销售）】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、负责游戏图片素材等需求的日常对接与协调；",
            "2、负责对接现有合作渠道，并做好日常关系维护和游戏导量合作安排；",
            "3、负责拓展新的合作渠道，做好合作风险把控；",
            "4、负责游戏数据的收集，合同、对账单、发票的审核、邮寄，做好合同、对账单、发票台账；",
            "5、负责对外合作渠道的款项跟进。",
          ],
          chaim: [
            "1、思路清晰、思维活跃，具有良好的逻辑思维能力和数据分析能力；",
            "2、具有较强的执行力及人际关系处理能力和敬业精神；",
            "3、熟练Office办公软件；",
            "4、热爱游戏，有志长期在游戏行业发展者优先。",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
        {
          name: "【Node.JS后端开发工程师】",
          title: "厦门",
          dutyName: "岗位职责：",
          chaimName: "任职要求：",
          duty: [
            "1、负责风领电商平台的服务端开发，包括接口设计、爬虫服务、数据存储等开发工作；",
            "2、参与相关数据采集分析及可视化系统建设；",
            "3、设计并开发基础框架、工具链、组件库等基础设施，不断提升开发体验和系统性能、稳定性；",
          ],
          chaim: [
            "1、大专及以上学历，计算机、通信和电子信息科学、数学等数理专业优先；",
            "2、具备扎实的计算机和编码基础，具有良好的逻辑理解能力和学习能力；",
            "3、擅长 TypeScript 或服务端（NodeJS、Mysql、Redis）等基础技术；",
            "4、熟悉 Docker、CI/CD，有良好的代码管理和版本管理习惯；",
            "【 加分项 】",
            "1、乐于分享，有 GitHub 开源作品；",
            "2、乐于使用新技术，有这方面案例；",
            "3、参与过有技术挑战性的项目或输出过有影响力的贡献；",
            "4、熟悉 macOS 开发环境；",
            "5、精通一门或者多门开发语言（Python、Ruby、Go等）或者有一定视觉与交互的技能；",
            "6、有代码洁癖，注重优雅的技术实现；",
          ],
          isShow: {
            title: "",
            isShowResume: true,
            isShowFileLogo: false,
            isShowUpLoad: false,
          },
          file: "",
        },
      ],
    };
  },
  methods: {
    showResume(e) {
      let index = e.target.dataset.index;
      this.list[index].isShow.isShowResume = false;
      this.list[index].isShow.isShowUpLoad = true;
    },
    selectFile(e) {
      let index = e.target.dataset.index;
      let title = this.$refs.dragFile[0].value.slice(
        this.$refs.dragFile[0].value.lastIndexOf(".") + 1
      );
      if (title != "pdf" && title != "docx" && title != "doc") {
        this.$refs.dragFile[0].value = "";
        this.$message({
          showClose: true,
          message: "请选择正确文档格式！！！",
          type: "error",
        });
        return;
      }
      this.list[index].isShow.isShowFileLogo = title ? true : false;
      this.list[index].title = title;
      this.list[index].file = event.target.files[0];
    },
    async upLoad(e) {
      let index = e.target.dataset.index;
      if (!this.list[index].file) {
        this.$message({
          showClose: true,
          message: "请先选择上传文件！！！",
          type: "error",
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", this.list[index].file);
      const res = await post(
        "http://game-general.feigo.fun/api/uploadfile",
        formData
      );
      if (res.code === 1000) {
        this.$message({
          showClose: true,
          message: "上传成功！！！",
          type: "success",
        });
        this.cancelUpLoad(e);
        this.list[index].file = "";
        this.list[index].title = "";
        this.$refs.dragFile[0].value = "";
        this.list[index].isShow.isShowFileLogo = false;
      } else {
        this.$message({
          showClose: true,
          message: "上传失败！！！",
          type: "error",
        });
        this.list[index].file = "";
        this.list[e.target.dataset.index].title = "";
        this.$refs.dragFile[0].value = "";
        this.list[e.target.dataset.index].isShow.isShowFileLogo = false;
      }
    },
    cancelUpLoad(e) {
      let index = e.target.dataset.index;
      this.list[index].title = "";
      this.list[index].isShow.isShowResume = true;
      this.list[index].isShow.isShowUpLoad = false;
      this.list[index].isShow.isShowFileLogo = false;
    },
  },
};
</script>

<style scoped>
.content {
  width: 60%;
  margin: 20px auto;
  background-color: #ffffff;
  border-radius: 5px;
}
h2 {
  margin: 10px;
}
.content-single {
  width: 90%;
  margin: 10px auto;
  margin-bottom: 20px;
  background-color: #ffffff;
  border-radius: 5px;
  border: 1px solid rgb(211, 211, 211);
  text-align: left;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.4);
}
.title {
  width: 100%;
  height: 80px;
  background-color: rgb(251, 251, 251);
  border: 1px solid rgb(211, 211, 211);
  margin-bottom: 20px;
}
h4,
h5,
p {
  margin-left: 25px;
}
@media screen and (max-width: 992px) {
  .content {
    width: 90%;
  }
  h4,
  h5,
  p {
    margin-left: 10px;
  }
}
@media screen and (max-width: 472px) {
  .content {
    width: 98%;
  }
  h2 {
    font-size: 25px;
  }
  h4 {
    font-size: 20px;
  }
  h5 {
    font-size: 18px;
  }
}
.container-resume {
  width: 100%;
  padding: 30px 25px;
}
.resume {
  width: 7.5rem;
  line-height: 35px;
  background: rgb(0, 150, 251);
  color: #ffffff;
  border-radius: 0.625rem;
  border: none;
  line-height: 2.5rem;
}
.resume:hover {
  background: rgb(0, 134, 251);
}
.light {
  width: 7.5rem;
  line-height: 40px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(230, 230, 230);
  border-radius: 0.625rem;
  color: rgb(160, 160, 160);
  margin-left: 1.875rem;
}
.light:hover {
  background: rgba(153, 153, 153, 0.4);
}
.resume-detail {
  border: 1px solid rgb(238, 238, 238);
  background: rgb(251, 252, 252);
  width: 5.5rem;
  height: 5.5rem;
  border-radius: 0.625rem;
  color: rgb(227, 227, 227);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.875rem;
}

.file {
  display: inline-block;
  background: #d0eeff;
  border: 1px solid #99d3f5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #1e88c7;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
  position: absolute;
  z-index: 5;
  width: 5.5rem;
  height: 5.5rem;
  opacity: 0;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}

.fileLogo {
  background: url(./file.png);
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  margin: 12px 5px;
  background-position-x: 4px;
  overflow: hidden;
}

@media screen and (max-width: 472px) {
  .light {
    margin-left: 0.875rem;
  }
}
</style>
